import React, { useRef, useEffect, useCallback } from "react";
import { earnedPointsStyle as styles } from "./earnedPoints.tailwind";
import ClaimBonusPoints from "./ClaimBonusPoints/ClaimBonusPoints";
import CurrentPolls from "./CurrentPolls/CurrentPolls";
import PreviousPollsResult from "./PreviousPollsResult/PreviousPollsResult";
// import UserPoints from "../../shared/UserPoints/UserPoints";
import { getBonusPoints, getCurrentPolls, getPreviousPolls } from "../../../../redux/slices/earnPointSlice";
import { useSelector, connect } from "react-redux";
import { FETCH_POLL_TYPE } from "../../../../lib/constants/globalConstant";

const EarnedPointsSection = ({ getBonusPoints, getActivePolls, getInactivePolls }) => {
  const { currentSeason } = useSelector(state => state.seasons);
  // const { userPointsAndRewards } = useSelector((state) => state.reward); 
  const bonusPoints = useSelector((state) => state.earnPoint.bonusPoints);
  
  const apiDataRef = useRef(false);

  const callApi = useCallback(async () => {
    if (apiDataRef.current) return;
    apiDataRef.current = true;
    getBonusPoints();
    const data = {
      seasonId: currentSeason?._id,
      sportId: currentSeason?.sportId,
    }

    getActivePolls({
      ...data,
      fetchType: FETCH_POLL_TYPE.CURRENT_POLLS
    });

    getInactivePolls({
      ...data,
      fetchType: FETCH_POLL_TYPE.PREVIOUS_POLLS
    });
  }, [getBonusPoints, currentSeason]);

  useEffect(() => {
    callApi();

    return () => {
      apiDataRef.current = false;
    }
  }, [callApi, currentSeason]);

  // const lifetime_points = userPointsAndRewards?.userTotalEarnedPoints;
  // const available_points = userPointsAndRewards?.userTotalAvailablePoints;

  return (
    <div className={styles.container}>
      {/* Claim Points and Poll */}
      <div className={styles.bonusAndPolls}>
        {/* <div className={styles.userPointsSection}>
          <UserPoints
            lifetime_points={lifetime_points}
            available_points={available_points}
          />
        </div> */}
        <ClaimBonusPoints bonusPoints={bonusPoints} /> {/* Claim Bonus Points */}
        {/* Previous Polls Result */}
        <PreviousPollsResult />
      </div>

      {/* User Points and Previous Poll results */}
      <div className={styles.pointsAndResults}>
        {/* User Points */}
        {/* <div className={styles.userPoint}>
          <UserPoints
            lifetime_points={lifetime_points}
            available_points={available_points}
          />{" "}
        </div> */}
        <CurrentPolls /> {/* Current Polls */}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getBonusPoints: () => dispatch(getBonusPoints()), // Dispatch `getBonusPoints` action
  getActivePolls: (data) => dispatch(getCurrentPolls(data)),
  getInactivePolls: (data) => dispatch(getPreviousPolls(data)),
});

export default connect(null, mapDispatchToProps)(EarnedPointsSection);
